import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = () => (
  <ContentLoader
    backgroundColor="var(--s-info-light)"
    foregroundColor="var(--interactive-secondary)"
    height={22}
    speed={2}
    viewBox="0 0 376 22"
    width={376}>
    <rect height="22" rx="0" ry="0" width="376" x="0" y="0" />
  </ContentLoader>
);

export default Loader;
